module.exports = __webpack_public_path__ + "static/media/facebook-icon-newpurple.08a81531.svg";